module.exports = __webpack_public_path__ + "static/img/icon_hzf.b8b259dc.png";